import { render, staticRenderFns } from "./TPSCreate.vue?vue&type=template&id=7d04b82e&"
import script from "./TPSCreate.vue?vue&type=script&lang=js&"
export * from "./TPSCreate.vue?vue&type=script&lang=js&"
import style0 from "./TPSCreate.vue?vue&type=style&index=0&id=7d04b82e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports